export interface BatchStatisticsGetPredefinedSettingRequest {
  selectId: string
}

export function BatchStatisticsGetPredefinedSettingRequestToJSON(
  value: BatchStatisticsGetPredefinedSettingRequest
): any {
  return {
    select_id: value.selectId
  }
}
